import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";

const API_URL = window.location.href.includes("localhost")
  ? process.env.REACT_APP_API_URL_LOCAL
  : process.env.REACT_APP_API_URL_PROD;

const AddClientForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    age: "",
    address: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const payload = { ...formData, source: "ADMIN" };

      await axios.post(`${API_URL}api/add-client-details-admin`, payload);

      setSuccessMsg("✅ Client added successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        age: "",
        address: "",
      });
    } catch (err) {
      console.error(err);
      setErrorMsg("❌ Failed to add client. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // 🔑 Submit only if Name is filled and (Email or Phone is provided)
  const isSubmitEnabled =
    formData.name.trim() !== "" &&
    (formData.email.trim() !== "" || formData.phone.trim() !== "");

  return (
    <Container maxWidth="sm" style={{ marginTop: "2rem" }} sx={{ py: 4 }}>
      <Paper
        elevation={4}
        sx={{
          p: { xs: 3, sm: 5 },
          borderRadius: 3,
          backgroundColor: "#fafafa",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          textAlign="center"
          sx={{ color: "primary.main" }}
        >
          Add Clients Data
        </Typography>

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                type="email"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                type="tel"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Age"
                name="age"
                value={formData.age}
                onChange={handleChange}
                type="number"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                sx={{
                  py: 1.5,
                  fontSize: "1rem",
                  borderRadius: 2,
                  textTransform: "none",
                }}
                disabled={loading || !isSubmitEnabled}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </Grid>
          </Grid>
        </Box>

        {successMsg && (
          <Typography
            variant="body1"
            color="success.main"
            textAlign="center"
            sx={{ mt: 3 }}
          >
            {successMsg}
          </Typography>
        )}

        {errorMsg && (
          <Typography
            variant="body1"
            color="error.main"
            textAlign="center"
            sx={{ mt: 3 }}
          >
            {errorMsg}
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default AddClientForm;
